import http from '@/support/plugin/axios'

export const 

//Verificar senha atual
isValidPasswordByCurrentId = ( password ) => http.get(`users/current/valid-password?password=${password}`),
//Mudar senha
updatePasswordByCurrentId = ( changePasswordObject ) => { 
    const body = {
        currentPassword: changePasswordObject.currentPassword,
        newPassword: changePasswordObject.newPassword
    }

    return http.patch('users/current/update-password', body)
}